/**
 * @file commonQueries.tsx
 *
 * @fileoverview Run common queries in apollo when server rendering.
 */

import { ApolloClient } from '@apollo/client';
import METATAGS_QUERY from '~/jobiqo/components/Metatag/graphql/metatags.gql';
import GET_MENU from '~/jobiqo/components/Header/graphql/getMenuAuth.gql';
import GET_SITE_CAMPAIGN from '~/jobiqo/components/Header/graphql/getSiteCampaign.gql';
import { removeUnusedItemsFromQuerystring } from '~/jobiqo/components/Metatag/utils';

interface CommonQueriesOptions {
  siteCampaignEnabled?: boolean;
}

export const commonQueries = async (
  ctx: any,
  apolloClient: ApolloClient<any>,
  path?: string,
  options?: CommonQueriesOptions,
) => {
  const pathToUse = path ?? ctx.resolvedUrl.split('?')[0];

  await apolloClient.query({
    query: METATAGS_QUERY,
    variables: {
      slug: removeUnusedItemsFromQuerystring(pathToUse),
      language: ctx.locale,
    },
  });

  await apolloClient.query({
    query: GET_MENU,
    variables: {
      main_menu_id: 'main',
      user_menu_id: 'account',
      language: ctx.locale,
    },
  });

  const siteCampaignEnabled =
    options?.siteCampaignEnabled ?? ctx?.siteCampaignEnabled;

  if (siteCampaignEnabled) {
    await apolloClient.query({
      query: GET_SITE_CAMPAIGN,
    });
  }
};
